import React, { useState } from "react";
import styles from "../styles/SignUp.module.css";

const SignUp = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [promoChecked, setPromoChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleContinue = () => {
    // Basic validation for demonstration
    if (!email || !password) {
      alert("Please fill in all fields.");
      return;
    }
    if (password.length < 8 || !/\d/.test(password)) {
      alert(
        "Password must contain at least 8 characters including at least 1 number."
      );
      return;
    }
    alert(`Signing up with email: ${email}, promotions: ${promoChecked}`);
  };

  return (
    <div className={styles.signupPage}>
      <div className={styles.signupContainer}>
        {/* Header */}
        <div className={styles.header}>
          <h1>Sign Up</h1>
        </div>

        {/* Email Input */}
        <div className={styles.inputGroup}>
          <span className={styles.inputIcon}>✉️</span>
          <input
            type="email"
            placeholder="Your Email Here"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.inputField}
          />
        </div>

        {/* Password Input */}
        <div className={styles.inputGroup}>
          <span className={styles.inputIcon}>🔒</span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Your Password Here"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.inputField}
          />
          <button
            className={styles.togglePassword}
            onClick={() => setShowPassword(!showPassword)}
          >
            👁️
          </button>
        </div>
        <p className={styles.passwordHint}>
          Password MUST contain at least 8 characters including at least 1
          number
        </p>

        {/* Promotional Checkbox */}
        <div className={styles.promoCheckbox}>
          <label>
            <input
              type="checkbox"
              checked={promoChecked}
              onChange={() => setPromoChecked(!promoChecked)}
            />
            I want to be the first to hear of the discounts, promotions and more
            on GiftShop
          </label>
        </div>

        {/* Sign In Link */}
        <p className={styles.signinLink}>
          Already have an account? <a href="/signin">Sign in here</a>
        </p>

        {/* Continue Button */}
        <button className={styles.continueButton} onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
};

export default SignUp;
